// service name
import { toLower } from 'lodash';

//todo statukset requested, user , closed

export const LIBREVIEW = 'Libreview';

export const KAYTTAJA = 'user';
export const SULJETTU = 'closed';
export const PYYDETTY = 'requested';

export const compareStatus = (status1, status2) => {
  return toLower(status1) === toLower(status2);
};

export default {
  LIBREVIEW,
  KAYTTAJA,
  SULJETTU,
  PYYDETTY,
};
